import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M16 8a4 4 0 1 0 -8 0v1a4 4 0 1 0 8 0","key":"svg-0"}],["path",{"d":"M8 16a4 4 0 1 0 8 0v-8","key":"svg-1"}]]

const IconNumber9 = createReactComponent('outline', 'number-9', 'Number9', __iconNode);

export default IconNumber9;